import { render } from "./SiteEcommerce.vue?vue&type=template&id=7b91005e&scoped=true"
import script from "./SiteEcommerce.vue?vue&type=script&lang=js"
export * from "./SiteEcommerce.vue?vue&type=script&lang=js"

import "./SiteEcommerce.vue?vue&type=style&index=0&id=7b91005e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b91005e"]])

export default __exports__